import { Library } from '../../types/library'
import { knownGrades } from '../../types/grade-value'
import { normalizeBugTrackers } from './bug-trackers'
import { buildLibraryCacheID } from '../../../../sca/libraries/api/graphql/library-row-query'

export function normalizeLibrary({
  hash,
  app_language: language,
  file_name: name,
  grade,
  group,
  score,
  classes_used,
  class_count,
  version,
  release_date: releaseDate,
  latest_version: latestVersion,
  latest_release_date: latestReleaseDate,
  ossEnabled,
  licenses,
  restricted: restrictedByOrg,
  invalid_version: invalidVersion,
  version_restriction: versionRestriction,
  tags,
  bugtracker_tickets: bugTrackers,
  apps: applications,
  mergedApps: mergedApplications,
  vulns: vulnerabilities,
  licenseViolation: restrictedLicense,
  library_class_usage_counts: libraryClassUsageCounts
}): Library {
  return {
    id: buildLibraryCacheID({ hash, language }),
    hash,
    language,
    name,
    grade: {
      score: score > -1 ? score : -1,
      value: knownGrades.indexOf(grade) > -1 ? grade : 'UNKNOWN'
    },
    group,
    usage: {
      total: class_count,
      totalUsed: classes_used
    },
    policies: {
      restrictedByOrg,
      invalidVersion,
      versionRestriction,
      restrictedLicense
    },
    versions: {
      current: {
        version,
        // This value can be zero in the REST endpoint
        releaseDate: mapReleaseDate(releaseDate)
      },
      latest: {
        version: latestVersion,
        // This value can be zero in the REST endpoint
        releaseDate: mapReleaseDate(latestReleaseDate)
      }
    },
    ossEnabled,
    licenses,
    tags: Array.isArray(tags) ? tags : [],
    bugTrackers: normalizeBugTrackers(bugTrackers),
    applications: applications
      ? applications.map(
          ({ app_id: appId, name, app_library_status: appLibraryStatus }) => ({
            id: `${appId}|${hash}`,
            appId,
            name,
            appLibraryStatus
          })
        )
      : [],
    mergedApplications: mergedApplications
      ? mergedApplications.map(
          ({ app_id: appId, name, app_library_status: appLibraryStatus }) => {
            return {
              id: `${appId}|${hash}`,
              appId,
              name,
              appLibraryStatus
            }
          }
        )
      : [],
    vulnerabilities: vulnerabilities
      ? vulnerabilities.map(
          ({
            name,
            description,
            authentication,
            references,
            visible,
            access_vector,
            access_complexity,
            availability_impact,
            confidentiality_impact,
            integrity_impact,
            severity_value,
            severity_code,
            has_cve,
            has_cvss3_score,
            cvss_3_vector,
            cvss_3_severity_value,
            cvss_3_severity_code
          }) => ({
            name,
            description,
            authentication,
            references,
            visible,
            accessVector: access_vector,
            accessComplexity: access_complexity,
            availabilityImpact: availability_impact,
            confidentialityImpact: confidentiality_impact,
            integrityImpact: integrity_impact,
            severityValue: parseFloat(severity_value.toFixed(1)),
            severityCode: severity_code,
            hasCve: has_cve,
            hasCvss3: has_cvss3_score,
            cvss3Vector: cvss_3_vector,
            cvss3SeverityValue: cvss_3_severity_value,
            cvss3SeverityCode: cvss_3_severity_code
          })
        )
      : undefined,
    libraryClassUsageCounts
  }
}

export function mapReleaseDate(val) {
  return !isNaN(val) && val <= 0 ? null : val
}
